import PropTypes from 'prop-types'

import {
  Box,
  Heading,
  TransparentButton,
  Icon,
  Text,
} from '@redriverpress/system'
import AddVideoToClassButton from './AddVideoToClassButton'

export default function VideoInfo({
  id,
  title,
  subtitle,
  date,
  // levels,
  description,
  categoryTitle,
  onSaveToFolder,
}) {
  return (
    <>
      <Box
        display='flex'
        justifyContent={[null, null, 'space-between']}
        flexDirection={['column', null, 'row']}
      >
        <Box>
          <Heading
            as='h1'
            fontSize={[2, null, 4]}
            lineHeight='heading'
            fontWeight='600'
            mb={0}
          >
            {title}
          </Heading>

          <Text
            mt={2}
            mb={[2, null, 0]}
            fontSize={[1, null, 2]}
            fontWeight='600'
          >
            {categoryTitle}
          </Text>

          {/* Optional sub-heading */}
          {subtitle && (
            <Box fontSize={1} mt={2} display='flex' alignItems='center'>
              <Text>{subtitle}</Text>
            </Box>
          )}
          {/* Optional sub-heading */}
          {date && (
            <Box fontSize={1} mt={2} display='flex' alignItems='center'>
              <Text>{date}</Text>
            </Box>
          )}
        </Box>
        <Box display='flex' alignItems='center'>
          <Box mt={[3, null, 0]}>
            <AddVideoToClassButton video={{ id, title }} />
          </Box>

          {/* Save video to folder Button */}
          <TransparentButton
            ml={2}
            bg='white'
            size='2.25rem'
            borderRadius='small'
            title='Save video to folder'
            onClick={onSaveToFolder}
            boxShadow={3}
          >
            <Icon icon='folder-open' />
          </TransparentButton>
        </Box>
      </Box>

      {/* {levels && <Text mt={2}>{levels}</Text>} */}

      {description && (
        <Text mt={2} measure>
          {description}
        </Text>
      )}
    </>
  )
}

VideoInfo.displayName = 'VideoInfo'

VideoInfo.defaultProps = {
  subtitle: null,
}

VideoInfo.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  categoryTitle: PropTypes.string.isRequired,
  description: PropTypes.string,
  levels: PropTypes.string,
  subtitle: PropTypes.string,
  onSaveToFolder: PropTypes.func.isRequired,
}
